import { VclTableDirective } from './vcltable.directive';
import { SpanDirective } from './span.directive';
import { HighlightDirective } from './highlight.directive';
import { SortDirective } from './sort.directive';
import { SelectDirective } from './select.directive';
import { SelectableDirective } from './selectable.directive';
import { DisableDirective } from './disable.directive';
import { AlignmentCenterDirective } from './alignmentcenter.directive';
import { AlignmentRightDirective } from './alignmentright.directive';
import { AlignmentbottomDirective } from './alignmentbottom.directive';
import { AlignmentMiddleDirective } from './alignmentmiddle.directive';
import { NoWrapDirective } from './nowrap.directive';
import { OverflowEllipsisDirective } from './overflowellipsis.directive';
import { BreakingWordsDirective } from './breakingwords.directive';

export let directives: any[] = [
  VclTableDirective,
  SpanDirective,
  HighlightDirective,
  SortDirective,
  SelectDirective,
  SelectableDirective,
  DisableDirective,
  AlignmentCenterDirective,
  AlignmentRightDirective,
  AlignmentbottomDirective,
  AlignmentMiddleDirective,
  NoWrapDirective,
  OverflowEllipsisDirective,
  BreakingWordsDirective
];
